export const stateKindEnum = Object.freeze({
    COMPANY:    1,
    CLIENT:     2
});